import { inject, InjectionToken } from '@angular/core';
import { map, Observable } from 'rxjs';

import { AppView } from '@app/core/enums/app-view.enum';
import { Themes } from '@app/core/enums/themes.enum';
import { ThemeService } from '@app/core/services/theme.service';

export const MOBILE_BREAKPOINT_WIDTH = 768;
export const MOBILE_BREAKPOINT_HEIGHT = 450;
export const TEXT_DIRECTION_TOKEN = new InjectionToken<string>(
  'TEXT_DIRECTION'
);
export const ENV_TOKEN = new InjectionToken<string>('ENV_TOKEN');
export const VIEW_TOKEN = new InjectionToken<AppView>('VIEW_TOKEN');
export const IS_DARK_MODE_TOKEN = new InjectionToken<Observable<boolean>>(
  'IS_DARK_MODE_TOKEN',
  {
    factory: (): Observable<boolean> =>
      inject(ThemeService).theme$.pipe(map((value) => value === Themes.Dark)),
  }
);
